import { render, staticRenderFns } from "./EditGroupType.vue?vue&type=template&id=15dcfaf6"
import script from "./EditGroupType.vue?vue&type=script&lang=js"
export * from "./EditGroupType.vue?vue&type=script&lang=js"
import style0 from "./EditGroupType.vue?vue&type=style&index=0&id=15dcfaf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports